module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4m.21113bc7.jpg";